module.exports = __webpack_public_path__ + "static/media/YB5M07_2.a93af5b7.jpg";